// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Common = require("../utils/Common.res.js");
var Parser = require("../../rescript-utils/main/Parser.res.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var Caml_splice_call = require("rescript/lib/js/caml_splice_call.js");

var operatorOrdered = "$*";

var operatorUnordered = "$/";

var operatorOneOf = "$|";

var openParenthesis = "$[";

var closeParenthesis = "$]";

var flagAdj = "+";

var flagNonAdj = "-";

var flagHyps = "H";

var flagHyp = "h";

var flagAsrt = "a";

var flagSingleStmt = "s";

var flagNegation = "!";

function toSymSeq(elems, flagsOpt) {
  var flags = flagsOpt !== undefined ? flagsOpt : ({
        adj: undefined,
        target: undefined,
        singleStmt: undefined
      });
  return {
          flags: flags,
          elems: elems
        };
}

var flagSingleHyp = flagHyps + flagSingleStmt;

function parseFlags(str) {
  var str$1 = str.replaceAll(flagHyp, flagSingleHyp);
  return {
          adj: str$1.includes(flagAdj) ? true : (
              str$1.includes(flagNonAdj) ? false : undefined
            ),
          target: str$1.includes(flagAsrt) ? "Asrt" : (
              str$1.includes(flagHyps) ? "Hyps" : undefined
            ),
          singleStmt: str$1.includes(flagSingleStmt) ? true : undefined
        };
}

function isPatternBegin(str) {
  if (str.startsWith("$") && !(str.startsWith(operatorOrdered) || str.startsWith(operatorUnordered) || str.startsWith(operatorOneOf) || str.startsWith(openParenthesis) || str.startsWith(closeParenthesis))) {
    return {
            flags: parseFlags(str),
            neg: str.includes(flagNegation),
            symSeq: {
              flags: {
                adj: undefined,
                target: undefined,
                singleStmt: undefined
              },
              elems: {
                TAG: "Symbols",
                _0: []
              }
            }
          };
  }
  
}

function passFlagsFromParentToChild(parentFlags, childFlags) {
  var match = parentFlags.target;
  var tmp;
  if (match !== undefined) {
    switch (match) {
      case "Frm" :
          tmp = childFlags.target;
          break;
      case "Hyps" :
      case "Asrt" :
          tmp = parentFlags.target;
          break;
      
    }
  } else {
    tmp = childFlags.target;
  }
  var match$1 = parentFlags.singleStmt;
  return {
          adj: Core__Option.orElse(childFlags.adj, parentFlags.adj),
          target: tmp,
          singleStmt: match$1 !== undefined && match$1 ? true : childFlags.singleStmt
        };
}

function makePattern(beginOpt, seq) {
  if (beginOpt !== undefined) {
    return {
            flags: beginOpt.flags,
            neg: beginOpt.neg,
            symSeq: seq
          };
  } else {
    return {
            flags: {
              adj: undefined,
              target: undefined,
              singleStmt: undefined
            },
            neg: false,
            symSeq: seq
          };
  }
}

var openParen = Parser.match(function (str) {
      if (str.startsWith(openParenthesis)) {
        return parseFlags(str);
      }
      
    });

var closeParen = Parser.map(Parser.val(closeParenthesis), (function (param) {
        
      }));

var symbol = Parser.match(function (str) {
      if (str.includes("$")) {
        return ;
      } else {
        return str;
      }
    });

var symbols = Parser.map(Parser.nonEmpty(Parser.rep(symbol, undefined, undefined)), (function (seq) {
        return toSymSeq({
                    TAG: "Symbols",
                    _0: seq
                  }, undefined);
      }));

var operator = Parser.oneOf([
      operatorOrdered,
      operatorUnordered,
      operatorOneOf
    ]);

var seqOperand = Parser.match(function (elem) {
      if (elem.TAG === "Seq") {
        return elem._0;
      }
      
    });

function seqGrpForOperator(operator, operand, makeGrp) {
  return Parser.map(Parser.map(Parser.seq2(Parser.nonEmpty(Parser.rep(Parser.map(Parser.seq2(operand, Parser.match(function (elem) {
                                          if (elem.TAG === "Seq" || elem._0 !== operator) {
                                            return ;
                                          } else {
                                            return Caml_option.some(undefined);
                                          }
                                        })), (function (param) {
                                    return param[0];
                                  })), undefined, undefined)), operand), (function (param) {
                    return param[0].concat([param[1]]);
                  })), (function (elems) {
                return toSymSeq(makeGrp(elems), undefined);
              }));
}

var ordered = seqGrpForOperator(operatorOrdered, seqOperand, (function (elems) {
        return {
                TAG: "Ordered",
                _0: elems
              };
      }));

var unordered = seqGrpForOperator(operatorUnordered, Parser.any([
          ordered,
          seqOperand
        ]), (function (elems) {
        return {
                TAG: "Unordered",
                _0: elems
              };
      }));

var oneOf = seqGrpForOperator(operatorOneOf, Parser.any([
          unordered,
          ordered,
          seqOperand
        ]), (function (elems) {
        return {
                TAG: "OneOf",
                _0: elems
              };
      }));

var seqGrpParser = Parser.any([
      oneOf,
      unordered,
      ordered
    ]);

function symSeq() {
  return Parser.anyL([
              seqGrp,
              seqWithParens,
              (function () {
                  return symbols;
                })
            ]);
}

function seqWithParens() {
  return Parser.map(Parser.seq3(openParen, symSeq(), closeParen), (function (param) {
                var seq = param[1];
                return {
                        flags: passFlagsFromParentToChild(param[0], seq.flags),
                        elems: seq.elems
                      };
              }));
}

function operand() {
  return Parser.any([
              seqWithParens(),
              symbols
            ]);
}

function operators() {
  return Parser.map(Parser.seq2(Parser.map(Parser.nonEmpty(Parser.rep(Parser.map(Parser.seq2(operand(), operator), (function (param) {
                                    return [
                                            {
                                              TAG: "Seq",
                                              _0: param[0]
                                            },
                                            {
                                              TAG: "Operator",
                                              _0: param[1]
                                            }
                                          ];
                                  })), undefined, undefined)), (function (__x) {
                        return Caml_splice_call.spliceObjApply([], "concat", [__x]);
                      })), operand()), (function (param) {
                return param[0].concat([{
                              TAG: "Seq",
                              _0: param[1]
                            }]);
              }));
}

function seqGrp() {
  return Parser.flatMap(operators(), (function (param) {
                return seqGrpParser;
              }));
}

var singlePattern = Parser.map(Parser.seq2(Parser.opt(Parser.match(isPatternBegin)), symSeq()), (function (param) {
        return makePattern(param[0], param[1]);
      }));

var nonSinglePattern = Parser.map(Parser.seq2(Parser.match(isPatternBegin), symSeq()), (function (param) {
        return makePattern(param[0], param[1]);
      }));

var patterns = Parser.end(Parser.any([
          Parser.nonEmpty(Parser.rep(nonSinglePattern, undefined, undefined)),
          Parser.map(singlePattern, (function (pat) {
                  return [pat];
                }))
        ]));

function parsePattern(text) {
  return Parser.parse(Common.getSpaceSeparatedValuesAsArray(text.trim()), patterns);
}

exports.parseFlags = parseFlags;
exports.passFlagsFromParentToChild = passFlagsFromParentToChild;
exports.parsePattern = parsePattern;
exports.operatorOrdered = operatorOrdered;
exports.operatorUnordered = operatorUnordered;
exports.operatorOneOf = operatorOneOf;
exports.openParenthesis = openParenthesis;
exports.closeParenthesis = closeParenthesis;
exports.flagAdj = flagAdj;
exports.flagNonAdj = flagNonAdj;
exports.flagHyps = flagHyps;
exports.flagHyp = flagHyp;
exports.flagAsrt = flagAsrt;
exports.flagSingleStmt = flagSingleStmt;
exports.flagNegation = flagNegation;
exports.isPatternBegin = isPatternBegin;
/* openParen Not a pure module */
